<template>
  <div class="projectDetail-container">
    <div class="introduce-content">
      <h2 class="project-title">
        {{ data.project_name }} By {{ data.project_artist }}
      </h2>
      <div class="about">
        {{ data.project_description }}
      </div>
      <div class="con-item">
        <!-- <p class="single-item">
          Price per token
          <span class="value">{{ getTokenPrice }}</span>
        </p> -->
        <slot name="projectItem" />
      </div>

      <div class="btn-wrap">
        <slot name="btnContent" />
      </div>
    </div>

    <div
      class="pictureDisplay cursor-pointer"
      @click="toTokenDetail(randomToken)"
    >
      <picFrame
        v-if="randomToken"
        class="pic-frame"
        :img-src="`${$config.normalRequestBaseUrl}/art/${randomToken}/png`"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    picFrame: () => import("@/components/basic/frame.vue"),
  },
  props: {
    data: {
      type: Object,
    },
    randomToken: {
      type: String,
    },
  },
  methods: {
    toTokenDetail(id) {
      this.$router.push(`/token/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.con-item {
  width: 100%;
  .single-item {
    overflow: hidden;
    padding: 16px 0 8px 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .title{
      float: left;
    }
    .value {
      float: right;
      color: rgba(255, 255, 255, 0.6);
    }
    .site {
      color: rgb(134, 181, 219);
    }
  }
}
.about {
  margin: 16px 0;
  color: rgba(255, 255, 255, 0.4);
}
.btn-wrap {
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  button {
    // width: 100%;
    padding: 12px 0px;
    color: #fff;
    background-color: #3b4d55;
    font-weight: 600;
    font-size: 18px;
    border-radius: 2px;
    outline: none;
    &:hover {
      border: none;
    }
  }
}
@media (max-width: 1025px) {
  .projectDetail-container {
    padding: 20px 0;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    .introduce-content {
      width: 100%;
      padding: 20px 0;
      .project-title {
        font-size: 16px;
      }
    }
  }
}

@media (min-width: 1026px) {
  .projectDetail-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 40px 0;
    .introduce-content {
      width: 45%;
      padding: 0px 20px;
      .project-title {
        font-size: 20px;
      }
    }
    .pictureDisplay {
      width: 45%;
      text-align: right;
    }
  }
}
</style>